var Clients = $.extend(false, BaseModule ,{
    api_route : 'clients',

    data : {
		module		: 'clients',
		page        : 1, 
        limit       : 20,
        order_by    : 'id:desc',
        view        : 'list'
	},
    
    after_load_entry : function(){
        "use strict";
        
        this.save();

        $('select[name="domains[]"]').on('select2:select', function (e) {
            var primary_val = e.params.data.text.trim();
            if($('input[name="default_domain"]').val()===''){
               $('input[name="default_domain"]').val(primary_val);
            }
        });

        $('input[name="default_domain"]').change(function() {
            if($(this).val()===''){
                  $('input[name="default_domain"]').prop('required',true);
                  $('input[name="default_domain"]').attr('data-fv-notempty','true');
                  $('input[name="default_domain"]').attr('data-fv-field','default_domain');
                  $('input[name="default_domain"]').attr('data-fv-empty___message','The Default Domain is required');
                  $('#clients_form').formValidation('addField', 'default_domain');  
            }else{
                 $('#clients_form').formValidation('removeField', 'default_domain');  
                 $('input[name="default_domain"]').parent().find('small.help-block').remove();
            }
        });
    },
	init:function(){
        
    }
});

$(document).ready(function(){
	Clients.init();
});